import * as ROUTES from '~/lib/routes';
export interface MenuLink {
  name: string; //Ref til id i translations
  url: string;
  external?: boolean;
}

export interface MenuGroup {
  header: string;
  links: MenuLink[];
}

export const MenuGroups: Array<MenuGroup> = [
  {
    header: 'navigation.reiseplanlegging',
    links: [ROUTES.reisesok, ROUTES.kart, ROUTES.trafikkmeldinger],
  },
  {
    header: 'navigation.reisMedTog',
    links: [
      ROUTES.ofteStilteSporsmal,
      ROUTES.togIEuropa,
      ROUTES.gruppereiser,
      ROUTES.betjentestasjoner,
    ],
  },
  {
    header: 'navigation.hjelpOgKontakt',
    links: [
      ROUTES.kontaktOss,
      ROUTES.aktuelleSaker,
      ROUTES.hittegods,
      ROUTES.assistanse,
      ROUTES.personalbillett,
    ],
  },
  {
    header: 'navigation.entur',
    links: [
      ROUTES.omEntur,
      ROUTES.omReiseplanleggeren,
      ROUTES.jobbientur,
      ROUTES.ledelsenIEntur,
    ],
  },
  {
    header: 'navigation.bedrift',
    links: [
      ROUTES.presse,
      ROUTES.komIGang,
      ROUTES.arsrapporter,
      //ROUTES.entursTjenester,
      ROUTES.forLeverandorer,
      ROUTES.transportorer,
    ],
  },
];
